import { trackSeoExplorePageInlineFilterClick } from "@faire/web-api/events/seo/click/explorePageInlineFilter";
import { IFilterSection } from "@faire/web-api/indigofair/data/IFilterSection";
import qs from "query-string";
import React from "react";

import { Banners } from "@faire/retailer/components/Banners/Banners";
import { ExploreBanner } from "@faire/retailer/components/Banners/ExploreBanners/ExploreBannerEnum";
import { useExplorePageBannersQuery } from "@faire/retailer/components/Banners/ExploreBanners/useExplorePageBannersQuery";
import { FilterPillTile } from "@faire/retailer/components/FilterPillTile/FilterPillTile";
import { IBannerData } from "@faire/retailer/lib/bannerUtils";
import { discoverSearch } from "@faire/retailer/lib/seoPaths";

export const ExploreBanners: React.FC<{ productSearchString: string }> = ({
  productSearchString,
}) => {
  const { bannersResponse, bannerDisplayData } =
    useExplorePageBannersQuery(productSearchString);

  const renderBanner = (banner: IBannerData<ExploreBanner>) => {
    if (banner.type !== ExploreBanner.FILTER_PILL_TILE) {
      return null;
    }

    const brandValueFilterOptions =
      bannersResponse?.filter_pill_banner?.brand_value_filter_options ?? [];
    return (
      <FilterPillTile
        brandValueFilterSection={IFilterSection.build({
          options: brandValueFilterOptions,
        })}
        pillLinkUrl={(filterOption) => {
          const stringifiedQueryParams = qs.stringify({
            filters: filterOption.key,
          });
          return `${discoverSearch(
            productSearchString
          )}?${stringifiedQueryParams}`;
        }}
        onClick={(filter) => {
          trackSeoExplorePageInlineFilterClick(filter);
        }}
      />
    );
  };

  return (
    <Banners
      renderBanner={renderBanner}
      banners={bannerDisplayData}
      name="explore-inline-element"
    />
  );
};
